import ToastEventBus from "./ToastEventBus";

function add(message) {
  ToastEventBus.emit("add", message);
}

function removeGroup(group) {
  ToastEventBus.emit("remove-group", group);
}

function removeAllGroups() {
  ToastEventBus.emit("remove-all-groups");
}

export function useToast() {
    return {
        add,
        removeGroup,
        removeAllGroups
    }
}
